export function RaceInfo({distance, type}) {
    return (
        <div className="race_live_info">
            { distance ? <span className="race_info_title">{distance}m {type}</span> : null }
        </div>
    );
  }
  
  